import Api from "./api.jsx";

import * as Constants from "../../../consts/Constants.js";

import auth from "../../auth/service";

const ADMIN_ROLE = 3001;

class EmergencyService {

	constructor(baseUrl) {
		this.api = new Api(baseUrl);
	}

	canAdmin() {
		return auth.hasRole(ADMIN_ROLE);
	}

}

export default new EmergencyService(Constants.FINAL_URL_EMERGENCY);